import { render } from "./SinistroAcordoDetalheView.vue?vue&type=template&id=401d17c0&scoped=true"
import script from "./SinistroAcordoDetalheView.vue?vue&type=script&lang=js"
export * from "./SinistroAcordoDetalheView.vue?vue&type=script&lang=js"

import "./SinistroAcordoDetalheView.vue?vue&type=style&index=0&id=401d17c0&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-401d17c0"]])

export default __exports__